import React, { useEffect, useState } from 'react';
import { Dropdown, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import IconButton from 'componentes/common/IconButton.js';
const AutocompleteDropdown = ({
  items,
  setValue,
  name,
  register,
  errors,
  currentSelected,
  setCurrentSelected,
  placeholder,
  addButton = false,
  addFunction
}) => {
  const [search, setSearch] = useState(currentSelected || '');
  const [show, setShow] = useState(false);

  const handleSelect = value => {
    setSearch(value.description);
    setShow(false);
  };

  const filteredItems =
    items.length == 0
      ? []
      : items.filter(item =>
          item.description.toLowerCase().includes(search.toLowerCase())
        );
  // Set default selected value from props
  useEffect(() => {
    setSearch(currentSelected);
  }, []);
  return (
    <>
      {placeholder && <label>{placeholder}</label>}
      {addButton && (
        <IconButton
          variant="falcon-default"
          size="sm"
          icon="plus"
          style={{ float: 'right', marginRight: '5px', fontSize: 'smallest' }}
          transform="shrink-3"
          onClick={() => addFunction()}
        >
          Agregar
        </IconButton>
      )}

      <Dropdown
        className="form-control"
        size="sm"
        show={show}
        onToggle={() => setShow(!show)}
      >
        <Dropdown.Toggle variant="Secondary" id="dropdown-autocomplete">
          {search || 'Selecciona un valor'}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <div className="px-3 py-2 position-relative">
            <FormControl
              autoFocus
              placeholder="Escribe para buscar..."
              onChange={e => setSearch(e.target.value)}
              value={search}
              type="search"
              onClick={e => e.stopPropagation()}
              className="shadow-none" // padding end for icon space
            />
          </div>
          <Dropdown.Divider />
          {filteredItems.length > 0 ? (
            filteredItems.map((item, idx) => (
              <Dropdown.Item
                key={idx}
                onClick={() => {
                  setValue(name, item.id, {
                    shouldValidate: true
                  });
                  // setSelected(item.id);
                  handleSelect(item);

                  if (setCurrentSelected) setCurrentSelected(item);
                }}
              >
                {item.description}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item disabled>Datos no encontrados</Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
      <input
        {...register(name, {
          required: 'Debes seleccionar un valor'
        })}
        type="hidden"
      />
      {errors[name]?.message}
    </>
  );
};
AutocompleteDropdown.propTypes = {
  items: PropTypes.array.isRequired,
  setValue: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setCurrentSelected: PropTypes.func,
  currentSelected: PropTypes.string,
  currentSelecnameted: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  addFunction: PropTypes.func,
  addButton: PropTypes.bool
};

export default AutocompleteDropdown;
